// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transactions-container-nx2vf {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.transactions-content-YEcAd {
  height: 100%;
  padding-left: 20px;
  overflow: hidden;
}

.transactions-table_container-TNyEW {
  padding-right: 10px;
}

.transactions-tableRow_cell-JKMfe:last-child {
  padding-right: 16px;
}

.transactions-phone-qHI_v {
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/business/transactions/transactions.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.content {\n  height: 100%;\n  padding-left: 20px;\n  overflow: hidden;\n}\n\n.table_container {\n  padding-right: 10px;\n}\n\n.tableRow_cell:last-child {\n  padding-right: 16px;\n}\n\n.phone {\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `transactions-container-nx2vf`,
	"content": `transactions-content-YEcAd`,
	"table_container": `transactions-table_container-TNyEW`,
	"tableRow_cell": `transactions-tableRow_cell-JKMfe`,
	"phone": `transactions-phone-qHI_v`
};
export default ___CSS_LOADER_EXPORT___;
